<mat-toolbar>
  <button mat-raised-button matTooltip="Volver" (click)="back()" color='primary'><mat-icon>arrow_back</mat-icon> Volver</button>
  <span class="spacer"></span>
  <button mat-icon-button matTooltip="Recargar datos" (click)="ngOnInit()"><mat-icon color="primary">refresh</mat-icon></button>
  <button mat-button [matMenuTriggerFor]="beforeMenu"><mat-icon color="primary">menu</mat-icon></button>
  <mat-menu #beforeMenu="matMenu" xPosition="before">
    <button mat-menu-item (click)='generarDocumento(false)' [disabled]="data.length === 0 || errorPesajes === true"><mat-icon color="primary">description</mat-icon> Documento</button>
    <button mat-menu-item (click)='generarDocumento(true)' [disabled]="data.length === 0 || errorPesajes === true"><mat-icon color="primary">summarize</mat-icon> Documento clasificado</button>
    @if (userRolCheck('permiso_total')) {
      <button mat-menu-item (click)='deleteAlbaran()' [disabled]='data.length == 0'><mat-icon color="primary">delete</mat-icon> Eliminar albarán</button>
    }
  </mat-menu>
</mat-toolbar>

@if (showProgressBar) {
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
}

<mat-card class='card'>

  <h1> Albarán Nº {{ albaran }} </h1>
  @if (data.length === 0) {
    <p>No hay datos disponibles...</p>
  }

  <mat-tab-group animationDuration="0ms">
    <mat-tab label="Pesajes">
      <div class='tabClass'>
        <mat-accordion>
          @for (albaran of data; track albaran; let i = $index) {
            <mat-expansion-panel>
              <mat-expansion-panel-header>
                <mat-panel-title>
                  Pesada #{{ (i + 1) }}
                </mat-panel-title>
                <mat-panel-description>
                  {{ albaran.material }} - {{ puntuarPeso(albaran.peso) }} Kg
                </mat-panel-description>
              </mat-expansion-panel-header>
              <mat-divider></mat-divider>
              <div class='bodyInfo'>
                <div class='imageBlock'>
                  @if (albaran.imagen !== 'not-found.png') {
                    <div>
                      <button mat-mini-fab [matMenuTriggerFor]="beforeMenu1" class='downloadImageButton' matTooltip="Descargar imagen" color="primary"><mat-icon>download_for_offline</mat-icon></button>
                      <mat-menu #beforeMenu1="matMenu" xPosition="before">
                        <button mat-menu-item (click)='descargarImagen(albaran.id, "original")'>Original</button>
                        <button mat-menu-item (click)='descargarImagen(albaran.id, "info")'>Original + Info</button>
                        <button mat-menu-item (click)='descargarImagen(albaran.id, "recortada")'>Recortada</button>
                        <button mat-menu-item (click)='descargarImagen(albaran.id, "recortada_info")'>Recortada + Info</button>
                      </mat-menu>
                    </div>
                  }
                  <img src="{{albaran.foto}}" alt='FOTO TOMADA POR CÁMARA BÁSCULA' title='FOTO TOMADA POR CÁMARA BÁSCULA' class='imageCaptured'>
                </div>
                <div>
                  <div class='actionButtonsBlock'>
                    @if (userRolCheck('permiso_registrosDatos')) {
                      <button mat-mini-fab matTooltip="Modificar pesaje" (click)='modificarPesaje(albaran.id)' color='primary'><mat-icon>create</mat-icon></button>
                    }
                    @if (userRolCheck('permiso_total')) {
                      <button mat-mini-fab matTooltip="Eliminar pesaje" (click)='eliminarPesaje(albaran.id)' color='primary'><mat-icon>delete</mat-icon></button>
                    }
                  </div>
                  <div class='tableBlock tableBlockMain'>
                    <table class='table'>
                      <tr>
                        <td class='mainCell'>Ref. peso:</td>
                        <td> {{ numSize(albaran.id, 12) }} </td>
                      </tr>
                      <tr>
                        <td class='mainCell'>Fecha:</td>
                        <td> {{ albaran.fecha }} </td>
                      </tr>
                      <tr>
                        <td class='mainCell'>Hora:</td>
                        <td> {{ albaran.hora }} </td>
                      </tr>
                      <tr>
                        <td class='mainCell'>Matricula:</td>
                        <td> {{ albaran.matricula }} </td>
                      </tr>
                      <tr>
                        <td class='mainCell'>Chófer:</td>
                        <td> {{ albaran.transportista }} </td>
                      </tr>
                      <tr>
                        <td class='mainCell'>Residuo:</td>
                        <td> {{ albaran.material }} </td>
                      </tr>
                      <tr>
                        <td class='mainCell'>Báscula:</td>
                        <td> {{ albaran.scale_name || '-' }} </td>
                      </tr>
                      <tr>
                        <td class='mainCell'>Peso registrado:</td>
                        <td> {{ puntuarPeso(albaran.peso) }} Kg </td>
                      </tr>
                      <tr>
                        <td class='mainCell'>Observaciones:</td>
                        <td> {{ albaran.descripcion }}</td>
                      </tr>
                    </table>
                  </div>
                </div>
              </div>
            </mat-expansion-panel>
          }
        </mat-accordion>
      </div>
    </mat-tab>
    <mat-tab label="Clasificación">
      <div class='tabClass'>
        @if (errorPesajes === true) {
          <span>
            Se ha producido un error al generar el resumen:
            <ul>
              <li>Revise que los pesajes sean correctos.</li>
              <li>Revise que <b>no</b> haya más de 2 pesajes por residuo.</li>
              <li>Contacte con el administrador.</li>
            </ul>
          </span>
        }
        <mat-accordion>
          @for (data of dataSource; track data; let i = $index) {
            <mat-expansion-panel>
              <mat-expansion-panel-header>
                <mat-panel-title>
                  {{ data.residuo }}
                </mat-panel-title>
                <mat-panel-description>
                  Pesaje: {{ data.neto }}Kg
                </mat-panel-description>
              </mat-expansion-panel-header>
              @for (clasi of data.clasificado; track clasi; let i = $index) {
                <div class='bodyInfo2' >
                  <div class='actionButtonsBlock alignRight'>
                    @if (userRolCheck('permiso_total')) {
                      <button mat-mini-fab matTooltip="Modificar clasificación" (click)='modificarClasificacion(clasi.id, clasi.id_residuo_clasificado, clasi.peso, clasi.descripcion, clasi.id_residuo)' color='primary'><mat-icon>edit</mat-icon></button>
                    }
                    @if (userRolCheck('permiso_total')) {
                      <button mat-mini-fab matTooltip="Eliminar clasificación" (click)='deleteClasificacion(clasi.id)' color='primary'><mat-icon>delete</mat-icon></button>
                    }
                  </div>
                  <div class='contentData'>
                    <div class='contentData2'>
                      <div class='imageBlock'>
                        @if (clasi.foto1.length > 0) {
                          <div>
                            <button mat-mini-fab (click)='downloadBase64File(clasi.foto1, "Clasificación_1")' class='downloadImageButton2' matTooltip="Descargar imagen" color="primary"><mat-icon>download_for_offline</mat-icon></button>
                            @if (clasi.foto1.length > 5) {
                              <img src="{{clasi.foto1}}" alt='FOTO 1 TOMADA POR EL CLASIFICADOR' title='FOTO 1 TOMADA POR EL CLASIFICADOR' class='imageCaptured2 imageCaptured2margin'>
                            }
                          </div>
                        }
                      </div>
                      <div class='imageBlock'>
                        @if (clasi.foto2.length > 0) {
                          <div>
                            <button mat-mini-fab (click)='downloadBase64File(clasi.foto2, "Clasificación_2")' class='downloadImageButton2' matTooltip="Descargar imagen" color="primary"><mat-icon>download_for_offline</mat-icon></button>
                            @if (clasi.foto2.length > 5) {
                              <img src="{{clasi.foto2}}" alt='FOTO 2 TOMADA POR EL CLASIFICADOR' title='FOTO 2 TOMADA POR EL CLASIFICADOR' class='imageCaptured2'>
                            }
                          </div>
                        }
                      </div>
                    </div>
                    <div>
                      <table class='table2'>
                        <tr>
                          <td class='mainCell'>Residuo:</td>
                          <td> {{ clasi.residuo_clasificado }} </td>
                        </tr>
                        <tr>
                          <td class='mainCell'>Peso:</td>
                          <td> {{ clasi.peso }}Kg </td>
                        </tr>
                        <tr>
                          <td class='mainCell'>Descripción:</td>
                          <td> {{ clasi.descripcion }} </td>
                        </tr>
                      </table>
                    </div>
                  </div>
                  <mat-divider></mat-divider>
                  <mat-divider></mat-divider>
                </div>
              }
            </mat-expansion-panel>
          }
        </mat-accordion>
      </div>
    </mat-tab>
    <mat-tab label="Resumen">
      <div class='tabClass'>
        @if (errorPesajes === true) {
          <span>
            Se ha producido un error al generar el resumen:
            <ul>
              <li>Revise que los pesajes sean correctos.</li>
              <li>Revise que <b>no</b> haya más de 2 pesajes por residuo.</li>
              <li>Contacte con el administrador.</li>
            </ul>
          </span>
        }
        @if (errorPesajes === false) {
          <table mat-table [dataSource]="dataSource" class='resumenTable'>
            <ng-container matColumnDef="residuo">
              <th mat-header-cell *matHeaderCellDef> Residuo </th>
              <td mat-cell *matCellDef="let element" class='residuoName'> {{element.residuo}} </td>
            </ng-container>
            <ng-container matColumnDef="peso1">
              <th mat-header-cell *matHeaderCellDef> Bruto </th>
              <td mat-cell *matCellDef="let element"> {{element.peso1}} Kg </td>
            </ng-container>
            <ng-container matColumnDef="peso2">
              <th mat-header-cell *matHeaderCellDef> Tara </th>
              <td mat-cell *matCellDef="let element"> {{element.peso2}} Kg </td>
            </ng-container>
            <ng-container matColumnDef="neto">
              <th mat-header-cell *matHeaderCellDef> Neto </th>
              <td mat-cell *matCellDef="let element"> {{element.neto}} Kg </td>
            </ng-container>
            <ng-container matColumnDef="clasificadoPesoTotal">
              <th mat-header-cell *matHeaderCellDef> Clasificado </th>
              <td mat-cell *matCellDef="let element"> {{element.clasificadoPesoTotal}} Kg </td>
            </ng-container>
            <ng-container matColumnDef="total">
              <th mat-header-cell *matHeaderCellDef> Total </th>
              <td mat-cell *matCellDef="let element"> {{element.total}} Kg </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
          </table>
        }
      </div>
    </mat-tab>
    <mat-tab label="Movimientos">
      <div class='tabClass'>
        <app-view-movimientos [albaranNum]="albaran"></app-view-movimientos>
      </div>
    </mat-tab>
  </mat-tab-group>

</mat-card>
